import HTTP from '@/api/HTTP';
import transformer from '@/services/compta/exerciceComptable/exerciceComptableServerTableDataTransformer';
import formatDateIso from '@/services/general/formatIsoDate';

const URL_BASE = 'commun/ExerciceComptable/';

export async function create(exerciceComptable) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', exerciceComptable);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(exerciceComptable) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', exerciceComptable);
  return response;
}

export async function getAll(search) {
  const inputServer = transformer(search);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function checkExercice(societeId, dateComptable) {
  const response = await HTTP.post(URL_BASE + 'pCheckExerciceAsync', {
    societeId: societeId,
    dateToCheck: formatDateIso(dateComptable),
  });
  return response;
}
